import React from 'react';
import {
  SectionImageAndListContainer,
  LeftSection,
  RightSection,
  StepList,
  StepItem,
  StepTitle,
  StepDescription,
  ContainerElement,
} from './SectionImageAndList.style';
import HeadLineComponent from 'common/HeadLine';
import DescriptionComponent from 'common/Description';
import NextImage from 'common/components/NextImage';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import { PrimaryLink } from 'containers/SaasModern/Banner/banner.style';
import { CenterElement } from '../Acculturation/Acculturation.style';
import Container from 'common/components/Container';
import { CenterHeader } from 'containers/SaasModern/SectionGrid/SectionGrid.style';
import { Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';

const SectionImageAndListComponent = ({ slice }) => {
  return (
    <Container>
      <SectionImageAndListContainer>
        <CenterHeader>
          <PrismicRichText
            field={slice.primary.title}
            components={{
              paragraph: ({ children }) => (
                <Typography
                  variant="h2"
                  sx={(theme) => ({
                    color: '#111927',
                    fontSize: `${saasModernTheme.space[12]}px`,
                    fontFamily: saasModernTheme.fontFamily,
                    margin: '0 auto',
                    fontWeight: 'bold',
                    strong: {
                      background:
                        saasModernTheme.customColor.backgroundTextGradient,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    },
                    [theme.breakpoints.down('sm')]: {
                      fontSize: `${saasModernTheme.space[8]}px`,
                    },
                  })}
                >
                  {children}
                </Typography>
              ),
            }}
          />
          <DescriptionComponent field={slice.primary.description} />
        </CenterHeader>
        <ContainerElement>
          <LeftSection>
            <NextImage
              field={slice.primary.image}
              priority={true}
              width="500"
              layout="intrinsic"
            />
          </LeftSection>
          <RightSection>
            <StepList>
              {slice.items.map((item, index) => (
                <StepItem key={index} data-aos="zoom-in">
                  <StepTitle>{item.title}</StepTitle>
                  <StepDescription>
                    <PrismicRichText field={item.description} />
                  </StepDescription>
                </StepItem>
              ))}
            </StepList>
          </RightSection>
        </ContainerElement>
        {slice.primary.cta && slice.primary.redirectcta && (
          <CenterElement>
            <PrimaryLink href={slice.primary.redirectcta} data-aos="zoom-in">
              {slice.primary.cta}
            </PrimaryLink>
          </CenterElement>
        )}
      </SectionImageAndListContainer>
    </Container>
  );
};

export default SectionImageAndListComponent;
